module.exports = __webpack_public_path__ + "img/light-mud-decal-21.eb6a5c17.png";